import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Compagnia } from 'src/app/models/compagnia';
import { CompagniaService } from 'src/app/services/compagnia.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { CompagnieFormComponent } from './dialogs/form/form.component';

@Component({
  selector: 'compagnie',
  templateUrl: './compagnie.component.html',
  styleUrls: ['./compagnie.component.scss']
})
export class CompagnieComponent implements OnInit {

  headingText: string = 'Compagnie';

  relations: string[] = ['gruppo', 'comune', 'comune.provincia'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  multipleSelection: boolean = false;
  selectionMode: boolean = true;
  showReset: boolean = false;
  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Indirizzo',
        internalName: 'fullAddress',
        sortDisabled: true,

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Gruppo',
        internalName: 'gruppo',

        sortDisabled: true,
        displayFunction: model => model.gruppo?.nome,
      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Telefono',
        internalName: 'tel',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Cellulare',
        internalName: 'cell',

      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Fax',
        internalName: 'fax',

      }
    ),

    new dataTableColumnDefinition(
      {
        humanName: 'Email',
        internalName: 'email',

      }
    ),
  ];
  constructor(public compagniaService: CompagniaService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<CompagnieComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,) {
    if (this.data?.selectionMode || this.data?.multipleSelection) {
      this.selectionMode = this.data?.selectionMode;
      this.multipleSelection = this.data?.multipleSelection;
      this.showReset = this.data?.showReset;
      this.headingText = 'Seleziona una compagnia';
    }
  }

  async ngOnInit() {

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (compagnia: Compagnia) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare la compagnia ${compagnia.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.compagniaService.delete(compagnia);
          this.toast.success('Compagnia eliminata.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione Compagnia fallita.", "Errore!");
    }
  }



  editFunction = async (compagnia: Compagnia) => {
    try {
      let dialogRef = this.dialog.open(CompagnieFormComponent, { data: compagnia });
      dialogRef.afterClosed().subscribe(async (data: Compagnia) => {
        if (data) {

          Object.assign(compagnia, data);

          await this.compagniaService.edit(compagnia);

          this.toast.success('Compagnia modificata');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica compagnia fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(CompagnieFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  save() {
    this.dialogRef?.close(this.index?.selection?.selected);
  }

  async handleCreation(compagnia?: Compagnia) {
    if (compagnia) {
      try {
        await this.compagniaService.create(compagnia)
        this.toast.success('Compagnia creata!')
      }
      catch (e) {
        this.toast.error('Creazione compagnia fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
